import { EpimsBaseEntityDto } from './epim-base.dto';
export class UomDto extends EpimsBaseEntityDto {

    UomId: string;

    UomName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}